/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  createShapeId,
  getIndexBelow,
  getIndexBetween,
  getIndicesBelow,
  pointInPolygon,
  StateNode,
  TLDrawShapeSegment,
  TLPointerEventInfo,
  TLUnknownShape,
  useEditor,
  Vec,
} from "tldraw"
import { LDPage } from "../../shared/LDPage"
import {
  CustomDrawShape,
  CustomDrawShapeProps,
} from "../../shared/CustomDrawShape"
import { LDGeoShape } from "../../shared/LDGeoShape"
import { getGeoShapePath } from "../shapes/draw/getGeoShapePath"
import { densifyLine } from "./CustomNudge"
import { LDInstanceMeta } from "../../shared/LDInstance"
import { Expr } from "../../shared/Expr"
import { Proportions } from "lucide-react"
import { parseSVGPath1 } from "../pages/TestSvg"
import { LDShape } from "../../shared/LDShape"

export function isPointInShape(
  point: { x: number; y: number },
  shape: { x: number; y: number; width: number; height: number },
): boolean {
  const { x, y } = point
  const { x: shapeX, y: shapeY, width, height } = shape

  return (
    x >= shapeX && x <= shapeX + width && y >= shapeY && y <= shapeY + height
  )
}
export function calculateArea(bounds: {
  minX: number
  minY: number
  maxX: number
  maxY: number
}): number {
  const width = bounds.maxX - bounds.minX
  const height = bounds.maxY - bounds.minY
  return width * height
}

export class BucketFill extends StateNode {
  static override id = "bucket-fill"

  info = {} as TLPointerEventInfo

  isPen = false
  isPenOrStylus = false

  markId = null as null | string

  override onEnter(info: TLPointerEventInfo): void {
    const editor = this.editor
    this.info = info

    const scaledPoint = this.editor.screenToPage(this.info.point)
    const shapesInside: TLUnknownShape[] = []

    editor.getPageShapeIds(this.editor.getCurrentPageId()).forEach((id) => {
      const shape = this.editor.getShape(id)
      if (
        shape &&
        (shape.type === "custom-draw" || shape.type === "custom-geo")
      ) {
        const shapeUtil = this.editor.getShapeUtil(shape)
        const shapeGeometry = shapeUtil.getGeometry(shape)

        // Convert the point to the shape's local coordinate space

        const scaledPoint2 = new Vec(scaledPoint.x, scaledPoint.y)

        const localPoint = scaledPoint2.sub({ x: shape.x, y: shape.y })

        if (pointInPolygon(localPoint, shapeGeometry.vertices)) {
          //console.log('area', calculateArea(shapeGeometry.bounds))
          shapesInside.push(shape)
        }
      }
    })
    if (shapesInside.length === 0) {
      return
    }
    const finalShape = shapesInside.sort((shape1: any, shape2: any) => {
      const shapeUtil1 = this.editor.getShapeUtil(shape1)
      const shapeUtil2 = this.editor.getShapeUtil(shape2)
      return (
        calculateArea(shapeUtil1.getGeometry(shape1).bounds) -
        calculateArea(shapeUtil2.getGeometry(shape2).bounds)
      )
    })[0] as CustomDrawShape | LDGeoShape

    this.editor.markHistoryStoppingPoint()

    //console.log(`Point is inside the shape ${finalShape.id}`)

    const newShapeId = createShapeId()
    const pageMeta = (this.editor.getCurrentPage() as LDPage).meta
    const layer = pageMeta.currentLayer

    const highestIndexBelow = editor
      .getCurrentPageShapes()
      .map((s) => s.index)
      .filter((i) => i < finalShape.index)
      .sort()[0]

    const index = getIndexBetween(highestIndexBelow, finalShape.index)
    // const segmentType = finalShape.props.segments[0].type
    //console.log(page)

    // console.log(
    //   "path",

    //   getGeoShapePath(finalShape).toDrawD({
    //     strokeWidth: 1,
    //     passes: 1,
    //     randomSeed: finalShape.id,
    //     offset: 0,
    //     roundness: Expr.evaluate(
    //       finalShape.props.parameterValues.roundness,
    //       pageMeta.parameterValues,
    //     ),
    //   }),
    // )

    const translatedSegments: TLDrawShapeSegment[] =
      finalShape.type === "custom-draw"
        ? finalShape.props?.segments.map((segment: any) => {
            const translatedPoints = segment.points.map((point: any) => {
              const translated = new Vec(point.x, point.y).add({
                x: finalShape.x,
                y: finalShape.y,
              })
              return { x: translated.x, y: translated.y, z: 1 }
            })
            return {
              type: "free",
              points: translatedPoints,
            }
          })
        : [
            {
              type: "free",
              points: densifyLine(
                parseSVGPath1(
                  getGeoShapePath(finalShape).toDrawD({
                    strokeWidth: 1,
                    passes: 1,
                    randomSeed: finalShape.id,
                    offset: 0,
                    roundness: Expr.evaluate(
                      finalShape.props.parameterValues.roundness,
                      pageMeta.parameterValues,
                    ),
                  }),
                )[0].map((point) => {
                  const translated = new Vec(point[0], point[1]).add({
                    x: finalShape.x,
                    y: finalShape.y,
                  })
                  return { x: translated.x, y: translated.y, z: 1 }
                }),
              ),
            },
          ]

    console.log({ translatedSegments })

    const previousFillBindings = editor.getBindingsInvolvingShape(
      finalShape,
      "fill",
    )
    console.log("previous", previousFillBindings)
    const previousFills = previousFillBindings.map((binding) =>
      editor.getShape(binding.fromId),
    )

    const instanceMeta = editor.getInstanceState().meta as LDInstanceMeta

    const currentColor = instanceMeta.fillColor
    console.log("fills", previousFillBindings)
    if (previousFills.length > 0) {
      console.log("0k")
      editor.updateShapes(
        previousFills.map((shape) => {
          return shape
            ? {
                id: shape.id,
                type: shape.type,
                props: {
                  ...shape.props,
                  parameterValues: {
                    ...(shape as CustomDrawShape | LDGeoShape).props
                      .parameterValues,
                    //visible: Expr.lit(true),
                    fillColor: Expr.lit(currentColor),
                  },
                },
              }
            : null
        }),
      )
    } else {
      if (finalShape.type == "custom-draw" && finalShape.props.isFill) {
        editor.updateShape({
          id: finalShape.id,
          type: "custom-draw",
          props: {
            ...finalShape.props,
            parameterValues: {
              fillColor: Expr.lit(currentColor),
            },
          },
        })
      } else {
        if (finalShape.type === "custom-geo") {
          editor.createShape<LDGeoShape>({
            index: index,
            type: "custom-geo",
            id: newShapeId,
            x: finalShape.x,
            y: finalShape.y,
            props: {
              ...finalShape.props,
              fill: true,
              parameterValues: {
                fillColor: Expr.lit(instanceMeta.fillColor),
                roundness: finalShape.props.parameterValues.roundness,
                visible: Expr.lit(true),
                opacity: Expr.lit(1),
              },
            },
          })
        } else {
          editor.createShape<CustomDrawShape>({
            index: index,
            type: "custom-draw",
            id: newShapeId,

            props: {
              isFill: true,
              isComplete: true,
              parameterValues: {
                fillColor: Expr.lit(currentColor),
                visible: Expr.lit(true),
                opacity: Expr.lit(1),
              },

              isPen: false,
              segments: translatedSegments,
              scale: 1,
              layer: layer,
            },
          })
        }
        //const newBindingId = createBindingId()
        editor.createBinding({
          //id: newBindingId,
          fromId: newShapeId,
          toId: finalShape.id,
          type: "fill",
        })
      }
    }
    editor.markHistoryStoppingPoint()
    this.parent.transition("idle", info)
  }
}
